// Utility to format salary values
export function formatSalary(amount: number | string | undefined | null, shorthand: boolean = false): string {
  if (amount === null || amount === undefined || amount === '') return '-';
  if (typeof amount === 'string') {
    const num = parseFloat(amount);
    if (isNaN(num)) return amount; // Return the string itself if not a number
    amount = num;
  }
  if (typeof amount !== 'number' || isNaN(amount)) return '-';
  if (amount === 0) return '$0';
  if (shorthand) {
    if (amount >= 1_000_000) {
      // Show up to 3 significant digits for millions
      if (amount % 1_000_000 === 0) {
        return `$${(amount / 1_000_000).toFixed(0)}M`;
      } else if (amount % 100_000 === 0) {
        return `$${(amount / 1_000_000).toFixed(2)}M`;
      } else {
        return `$${(amount / 1_000_000).toFixed(3)}M`;
      }
    } else if (amount >= 1_000) {
      // No decimals for thousands
      return `$${Math.round(amount / 1_000)}K`;
    } else {
      return `$${amount}`;
    }
  } else {
    return `$${amount.toLocaleString()}`;
  }
} 